import React, { MutableRefObject, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 * @param {MutableRefObject} ref - React ref object attached to the container
 * @param {Function} handler - Function to call when a click outside is detected
 */
function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

export default useOnClickOutside;
